module.exports = __webpack_public_path__ + "static/media/marl.c76099f7.png";